import React, { Component } from "react";
import { Container, Row, Col, Table, Form } from "react-bootstrap";
import { connect } from "react-redux";
import AppSpinner from "../AppSpinner/AppSpinner";
import apiUrl from "../../utils/apiUrl";
import formatMoney from "../../utils/formatMoney";
import {
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  LineChart,
  Line,
} from "recharts";
import "./styles/styles.scss";

const select = (state) => {
  return {
    token: state.auth.token,
  };
};

const formatThousands = (decimal) =>
  decimal > 1000000
    ? `${decimal / 1000000}m`
    : decimal > 1000
    ? `${decimal / 1000}k`
    : decimal;

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload) {
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "rgba(245, 245, 245, 0.85)",
          padding: "15px",
          border: "1px solid #000",
          borderRadius: "3px",
        }}
      >
        <div>
          <strong>{label}</strong>
        </div>
        <div className="label" style={{ color: "#8884D8" }}>
          {payload[0] && `Recibido: $${formatMoney(payload[0].value)}`}
        </div>
        <div className="label" style={{ color: "#82CA9D" }}>
          {payload[1] && `Facturado: $${formatMoney(payload[1].value)}`}
        </div>
      </div>
    );
  }

  return null;
};

const CustomTooltipSubscriptions = ({ active, payload, label }) => {
  if (active && payload) {
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "rgba(245, 245, 245, 0.85)",
          padding: "15px",
          border: "1px solid #000",
          borderRadius: "3px",
        }}
      >
        <div>
          <strong>{label}</strong>
        </div>
        <div className="label" style={{ color: "#8884D8" }}>
          {payload[0] && `Total: $${formatMoney(payload[0].value)}`}
        </div>
        <div className="label" style={{ color: "#82CA9D" }}>
          {payload[1] && `Ingresos: $${formatMoney(payload[1].value)}`}
        </div>
      </div>
    );
  }

  return null;
};

const CustomTooltipSubscribedFoundations = ({ active, payload, label }) => {
  if (active && payload) {
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "rgba(245, 245, 245, 0.85)",
          padding: "15px",
          border: "1px solid #000",
          borderRadius: "3px",
        }}
      >
        <div>
          <strong>{label}</strong>
        </div>
        <div className="label" style={{ color: "#8884D8" }}>
          {payload[0] && `Fundaciones: ${payload[0].value}`}
        </div>
      </div>
    );
  }

  return null;
};

class ConnectedDashboardComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      data: {},
      nibiData: true,
      cemexData: false,
    };

    this.getStagePrograms = this.getStagePrograms.bind(this);
  }

  async componentDidMount() {
    const { token } = this.props;
    const dataResponse = await fetch(
      `${apiUrl}/admin/dashboard?token=${token}`
    );
    const dataJson = await dataResponse.json();

    if (dataJson.success)
      this.setState({ data: dataJson.data, isLoading: false });
  }

  getStagePrograms() {
    const { data } = this.state;
    const { programsInfo } = data;
    const programs = [];

    programsInfo.forEach((obj) => {
      const { _id, count } = obj;
      let title = "";
      let validStage = false;

      if (_id === 1) {
        validStage = true;
        title = "activos";
      }
      if (_id === 2) {
        validStage = true;
        title = "antes de ejecutar";
      }
      if (_id === 3) {
        validStage = true;
        title = "en ejecución";
      }
      if (_id === 4) {
        validStage = true;
        title = "ejecutados";
      }

      if (validStage) {
        programs.push(
          <Col lg={4} key={_id}>
            <h5>
              <strong># Programas {title}: </strong>
              {count}
            </h5>
          </Col>
        );
      }
    });

    return programs;
  }

  render() {
    const { isLoading, data, nibiData, cemexData } = this.state;

    const {
      foundations,
      users,
      enterprises,
      benefits,
      programs,
      totalRedeemedBenefits,
      totalDonations,
      totalSales,
      programDonors,
      foundationDonors,
      donationsPerMonth,
      subscriptionsPerMonth,
      pendingDisbursements,
      realizedDisbursments,
      race2020Payments,
      recurringDonors,
      totalRecurringUsers,
      foundationDisbursments,
      commerceDisbursments,
      orgRealizedDisbursements,
      commerceRealizedDisbursements,
      cemexSummary,
      cemexAssignedDonations,
      cemexPendingDonations,
      cemexPaymentsPerMonth = [],
    } = data;

    console.log(subscriptionsPerMonth);

    if (isLoading) return <AppSpinner />;

    const cemexDonationsInfo = cemexSummary
      ? cemexSummary.find((item) => item._id === "BENEFIT_PAYMENT")
      : null;
    const cemexSalesInfo = cemexSummary
      ? cemexSummary.find((item) => item._id === "PURCHASE")
      : null;

    const donations =
      (nibiData ? totalDonations.count : 0) +
      (cemexData && cemexDonationsInfo ? cemexDonationsInfo.total : 0);
    const sales =
      (nibiData ? totalSales.count : 0) +
      (cemexData && cemexSalesInfo ? cemexSalesInfo.total : 0);

    const donationAmount =
      (nibiData ? totalDonations.totalAmount : 0) +
      (cemexData && cemexDonationsInfo ? cemexDonationsInfo.totalAmount : 0);
    const salesAmount =
      (nibiData ? totalSales.totalAmount : 0) +
      (cemexData && cemexSalesInfo ? cemexSalesInfo.totalAmount : 0);

    const totalNibiDonations =
      (nibiData ? totalDonations.totalNibi : 0) +
      (cemexData && cemexDonationsInfo ? cemexDonationsInfo.nibiFee : 0);
    const totalNibiSales =
      (nibiData ? totalSales.totalNibi : 0) +
      (cemexData && cemexSalesInfo ? cemexSalesInfo.nibiFee : 0);

    const pendingDisbursementsAmount =
      (nibiData ? pendingDisbursements : 0) +
      (cemexData && cemexAssignedDonations ? cemexAssignedDonations : 0);
    const receivedDisbursementAmount =
      (nibiData ? realizedDisbursments : 0) +
      (cemexData && cemexPendingDonations ? cemexPendingDonations : 0);
    const transactionsPerMonth = [];

    let i = 0;
    let j = 0;

    while (i < cemexPaymentsPerMonth.length || j < donationsPerMonth.length) {
      if (i >= cemexPaymentsPerMonth.length) {
        const currJ = donationsPerMonth[j];
        transactionsPerMonth.push(currJ);
        j++;
      } else if (j >= donationsPerMonth.length) {
        const currI = cemexPaymentsPerMonth[i];
        transactionsPerMonth.push(currI);
        i++;
      } else {
        const currI = cemexPaymentsPerMonth[i];
        const currJ = donationsPerMonth[j];

        const dateI = new Date(`${currI._id.year}-${currI._id.month}-01`);
        const dateJ = new Date(`${currJ._id.year}-${currJ._id.month}-01`);

        if (dateI < dateJ) {
          transactionsPerMonth.push(currI);
          i++;
        } else if (dateJ < dateI) {
          transactionsPerMonth.push(currJ);
          j++;
        } else {
          transactionsPerMonth.push({
            count: currI.count + currJ.count,
            donaciones: currI.donaciones + currJ.donaciones,
            facturado: currI.facturado + currJ.facturado,
            label: currI.label,
          });

          i++;
          j++;
        }
      }
    }

    let transactionData = [];

    if (nibiData && cemexData) transactionData = transactionsPerMonth;
    else if (nibiData) transactionData = donationsPerMonth;
    else if (cemexData) transactionData = cemexPaymentsPerMonth;

    return (
      <div className="foundations-component">
        <Container>
          <Row>
            <Col xs={12}>
              <h2 style={{ marginBottom: "25px" }}>Datos Generales</h2>
            </Col>
            <Col lg={4}>
              <h5>
                <strong># Usuarios: </strong>
                {users}
              </h5>
            </Col>
            <Col lg={4}>
              <h5>
                <strong># Organizaciones validadas: </strong>
                {foundations}
              </h5>
            </Col>
            <Col lg={4}>
              <h5>
                <strong># Comercios validados: </strong>
                {enterprises}
              </h5>
            </Col>
            <Col lg={4}>
              <h5>
                <strong># Programas: </strong>
                {programs}
              </h5>
            </Col>
            <Col lg={4}>
              <h5>
                <strong># Beneficios: </strong>
                {benefits}
              </h5>
            </Col>
            <Col lg={4}>
              <h5>
                <strong># Redenciones: </strong>
                {totalRedeemedBenefits}
              </h5>
            </Col>
            <Col lg={4}>
              <h5>
                <strong># Inscritos a carrera: </strong>
                {race2020Payments}
              </h5>
            </Col>
            <Col lg={4}>
              <h5>
                <strong># Donantes recurrentes activos: </strong>
                {totalRecurringUsers}
              </h5>
            </Col>
          </Row>
          <br />
          <Row>
            {this.getStagePrograms()}
            <Col xs={12}>
              <hr />
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <h2 style={{ marginBottom: "25px" }}>Datos Financieros</h2>
              <Form.Check
                type="checkbox"
                label="Nibi"
                checked={nibiData}
                onChange={() => this.setState({ nibiData: !nibiData })}
              />
              <Form.Check
                type="checkbox"
                label="Cemex"
                checked={cemexData}
                onChange={() => this.setState({ cemexData: !cemexData })}
              />
              <br />
            </Col>
            <Col lg={3}>
              <h6>
                <strong># Donaciones: </strong>
                {donations}
              </h6>
              <h6>
                <strong># Compras: </strong>
                {sales}
              </h6>
            </Col>
            <Col lg={3}>
              <h6>
                <strong>$ Total en donaciones: </strong>$
                {formatMoney(donationAmount)}
              </h6>
              <h6>
                <strong>$ Total en compras: </strong>${formatMoney(salesAmount)}
              </h6>
            </Col>
            <Col lg={3}>
              <h6>
                <strong>$ Total facturado donaciones: </strong>$
                {formatMoney(totalNibiDonations)}
              </h6>
              <h6>
                <strong>$ Total facturado compras: </strong>$
                {formatMoney(totalNibiSales)}
              </h6>
            </Col>
            <Col lg={3}>
              <h6>
                <strong>$ Total desembolsos pendientes: </strong>$
                {formatMoney(pendingDisbursementsAmount)}
              </h6>
              <h6>
                <strong>$ Total desembolsos realizados: </strong>$
                {formatMoney(receivedDisbursementAmount)}
              </h6>
            </Col>
            <Col xs={12}>
              <hr />
              <h2 style={{ textAlign: "center" }}>Información de donaciones</h2>
            </Col>

            <Col xs={12}>
              <div style={{ width: "100%", height: 400 }}>
                <ResponsiveContainer>
                  <BarChart
                    width={500}
                    height={300}
                    data={transactionData}
                    margin={{
                      top: 20,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="label" />
                    <YAxis
                      yAxisId="left"
                      tickFormatter={formatThousands}
                      orientation="left"
                      stroke="#8884D8"
                    />
                    <YAxis
                      yAxisId="right"
                      tickFormatter={formatThousands}
                      orientation="right"
                      stroke="#82CA9D"
                    />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend />
                    <Bar yAxisId="left" dataKey="donaciones" fill="#8884D8" />
                    <Bar yAxisId="right" dataKey="facturado" fill="#82CA9D" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </Col>
            <Col xs={12}>
              <hr />
              <h2 style={{ textAlign: "center" }}>
                Información de suscripciones
              </h2>
            </Col>

            <Col xs={12}>
              <div style={{ width: "100%", height: 400 }}>
                <ResponsiveContainer>
                  <BarChart
                    width={500}
                    height={300}
                    data={subscriptionsPerMonth}
                    margin={{
                      top: 20,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="label" />
                    <YAxis
                      yAxisId="left"
                      tickFormatter={formatThousands}
                      orientation="left"
                      stroke="#8884D8"
                    />
                    <YAxis
                      yAxisId="right"
                      tickFormatter={formatThousands}
                      orientation="right"
                      stroke="#82CA9D"
                    />
                    <Tooltip content={<CustomTooltipSubscriptions />} />
                    <Legend />
                    <Bar yAxisId="left" dataKey="total" fill="#8884D8" />
                    <Bar yAxisId="right" dataKey="ingresos" fill="#82CA9D" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </Col>

            <Col xs={12}>
              <hr />
              <h2 style={{ textAlign: "center" }}>
                Fundaciones suscritas por mes
              </h2>
            </Col>
            <Col xs={12}>
              <div style={{ width: "100%", height: 400 }}>
                <ResponsiveContainer>
                  <LineChart
                    width={500}
                    height={300}
                    data={subscriptionsPerMonth}
                    margin={{
                      top: 20,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="label" />
                    <YAxis yAxisId="left" orientation="left" stroke="#8884D8" />
                    <Tooltip content={<CustomTooltipSubscribedFoundations />} />
                    <Legend />
                    <Line yAxisId="left" dataKey="count" stroke="#8884D8" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </Col>
          </Row>
          <hr />
          <Row className="tablesSection">
            <Col lg={6}>
              <h5>Donaciones por programa:</h5>

              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>Programa (Organización)</th>
                    <th>Total donaciones</th>
                  </tr>
                </thead>
                <tbody>
                  {programDonors.map((data, index) => (
                    <tr key={index}>
                      <td>
                        {data.programName} ({data.foundationName})
                      </td>
                      <td>{data.total}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <h5>Donaciones por organización:</h5>

              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>Organización</th>
                    <th>Total donaciones</th>
                  </tr>
                </thead>
                <tbody>
                  {foundationDonors.map((data) => (
                    <tr key={data.foundationId}>
                      <td>{data.foundationName}</td>
                      <td>{data.totalDonors}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <h5>Donantes recurrentes por organización:</h5>

              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>Organización</th>
                    <th>Total donantes recurrentes</th>
                  </tr>
                </thead>
                <tbody>
                  {recurringDonors.map((data) => (
                    <tr key={data._id}>
                      <td>{data._id}</td>
                      <td>{data.count}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>

            <Col lg={6}>
              <h5>Desembolsos pendientes:</h5>

              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>Organización</th>
                    <th>
                      Total desembolso ${" "}
                      {formatMoney(
                        foundationDisbursments.reduce(
                          (acc, val) => acc + val.totalDebt,
                          0
                        )
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {foundationDisbursments.map((data) => (
                    <tr key={data._id}>
                      <td>{data.foundationName}</td>
                      <td>$ {formatMoney(data.totalDebt)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>Comercio</th>
                    <th>
                      Total desembolso ${" "}
                      {formatMoney(
                        commerceDisbursments.reduce(
                          (acc, val) => acc + val.totalDebt,
                          0
                        )
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {commerceDisbursments.map((data) => (
                    <tr key={data._id}>
                      <td>{data.commerceName}</td>
                      <td>$ {formatMoney(data.totalDebt)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <h5>Desembolsos realizados:</h5>

              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>Organización</th>
                    <th>
                      Total desembolso ${" "}
                      {formatMoney(
                        orgRealizedDisbursements.reduce(
                          (acc, val) => acc + val.total,
                          0
                        )
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {orgRealizedDisbursements.map((data) => (
                    <tr key={data._id}>
                      <td>{data.foundationName}</td>
                      <td>$ {formatMoney(data.total)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>Comercio</th>
                    <th>
                      Total desembolso ${" "}
                      {formatMoney(
                        commerceRealizedDisbursements.reduce(
                          (acc, val) => acc + val.total,
                          0
                        )
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {commerceRealizedDisbursements.map((data) => (
                    <tr key={data._id}>
                      <td>{data.commerceName}</td>
                      <td>$ {formatMoney(data.total)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const DashboardComponent = connect(select)(ConnectedDashboardComponent);

export default DashboardComponent;
